import React, { useEffect, useRef } from 'react';
import BdDevFn_Com from '../../SharedTemplate/BdDevFn';
import cssFn from "../../../component/utilities/css/cssFunction";
import socketIOClient from "socket.io-client";

function TpWcpuLayout(props) {
    const timerRef = useRef(null);
    const pageClose = useRef(false);

    useEffect(() => {
        timerRef.current = setInterval(async() => {
            // console.log("Refresh");
            await reloadStatus();
        }, 300000);       /** 300*1000s , 5 mins*/

        let socket;
        async function startUp() {
            socket = socketIOClient(process.env.REACT_APP_PUBLIC_URL_DATALOG);
            await reloadStatus();

            let{ type, bdDev_id }= props;
            // let topic = `v2_${type}_${_id}`;
            let topic = `v1_${type}_${bdDev_id}`;
            // console.log("Socket IO topic: ", topic);
            socket.on(topic, async (data) => {
                // console.log("reload");
                // console.log(data);                                
                // let lastData = await BdDevFn_Com.loadLastData(props.devInfo);
                // if(lastData) setG_Lastdata(lastData);
                await reloadStatus();
            });
        }
        
        startUp();
        
        return ()=>{
            clearInterval(timerRef.current);
            socket.disconnect();
            pageClose.current = true;
            // alert("AddDevicePg Page Close");
        }
    });

    const reloadStatus = async () => {
        let devInfo = { ht: props.type, bdDev_id: props.bdDev_id };
        let lastData = await BdDevFn_Com.loadLastData(devInfo);
        // console.log(lastData.pf_2);
        let sensorTimeout = BdDevFn_Com.sensorTimeout(lastData);

        cssFn.cssShowStatus(false, `wcpu_${props.bdDev_id}`, "pdc_run_bg");
        cssFn.cssShowStatus(false, `wcpu_${props.bdDev_id}`, "pdc_run_border");
        cssFn.cssShowStatus(false, `wcpu_${props.bdDev_id}`, "pdc_error");
        cssFn.cssShowStatus(false, `wcpu_${props.bdDev_id}`, "pdc_resetError");
        cssFn.cssShowStatus(false, `wcpu_${props.bdDev_id}`, "pdc_offline");
        cssFn.cssShowStatus(false, `wcpu_${props.bdDev_id}`, "pdc_comError");

        if(sensorTimeout) {
            cssFn.cssShowStatus(true, `wcpu_${props.bdDev_id}`, "pdc_offline");
        } else if(lastData.pf_2 > 0) { //com error
            cssFn.cssShowStatus(true, `wcpu_${props.bdDev_id}`, "pdc_comError");
        } else{
            // check running
            if(lastData.pb_0 === 1) cssFn.cssShowStatus(true, `wcpu_${props.bdDev_id}`, "pdc_run_bg");
            // chekc err
            if(lastData.pb_10 === 1){  // critical err
                cssFn.cssShowStatus(true, `wcpu_${props.bdDev_id}`, "pdc_error");
            }else if(lastData.pb_11 === 1){  // resettable err
                cssFn.cssShowStatus(true, `wcpu_${props.bdDev_id}`, "pdc_resetError");
            }else if(lastData.pb_0 === 1){  // run
                cssFn.cssShowStatus(true, `wcpu_${props.bdDev_id}`, "pdc_run_border");
            }
        }
        
        // console.log(sensorTimeout);
        // if(sensorTimeout) {
        //     cssFn.cssShowStatus(false, `wcpu_${props.bdDev_id}`, "pdc_run_bg");
        //     cssFn.cssShowStatus(false, `wcpu_${props.bdDev_id}`, "pdc_run_border");
        //     cssFn.cssShowStatus(false, `wcpu_${props.bdDev_id}`, "pdc_error");
        //     cssFn.cssShowStatus(false, `wcpu_${props.bdDev_id}`, "pdc_resetError");
        //     cssFn.cssShowStatus(true, `wcpu_${props.bdDev_id}`, "pdc_offline");
        // } else {
        //     cssFn.cssShowStatus(false, `wcpu_${props.bdDev_id}`, "pdc_offline");
        //     if(lastData.pb_0 === 1)
        //         cssFn.cssShowStatus(true, `wcpu_${props.bdDev_id}`, "pdc_run_bg");
        //     else if(lastData.pb_0 === 0)
        //         cssFn.cssShowStatus(false, `wcpu_${props.bdDev_id}`, "pdc_run_bg");

        //     if(lastData.pb_11 === 0 && lastData.pb_10 === 0) {
        //         cssFn.cssShowStatus(false, `wcpu_${props.bdDev_id}`, "pdc_resetError");
        //         cssFn.cssShowStatus(false, `wcpu_${props.bdDev_id}`, "pdc_error");
        //         cssFn.cssShowStatus(true, `wcpu_${props.bdDev_id}`, "pdc_run_border");
        //     }
        //     else {
        //         if(lastData.pb_11 === 1) {
        //             cssFn.cssShowStatus(false, `wcpu_${props.bdDev_id}`, "pdc_run_border");
        //             cssFn.cssShowStatus(false, `wcpu_${props.bdDev_id}`, "pdc_offline");
        //             cssFn.cssShowStatus(false, `wcpu_${props.bdDev_id}`, "pdc_error");
        //             cssFn.cssShowStatus(true, `wcpu_${props.bdDev_id}`, "pdc_resetError");
        //         } else if(lastData.pb_10 === 1) {
        //             cssFn.cssShowStatus(false, `wcpu_${props.bdDev_id}`, "pdc_run_border");
        //             cssFn.cssShowStatus(false, `wcpu_${props.bdDev_id}`, "pdc_offline");
        //             cssFn.cssShowStatus(false, `wcpu_${props.bdDev_id}`, "pdc_resetError");
        //             cssFn.cssShowStatus(true, `wcpu_${props.bdDev_id}`, "pdc_error");
        //         }
        //     }
        // }
    }

    return ( <div>
        <div id={`wcpu_${props.bdDev_id}`} className='pdc_nodeCard'>{props.name}</div>
    </div> );
}

export default TpWcpuLayout;